module.exports = __webpack_public_path__ + "img/about-banner.532671dc.png";